import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import TableContent from "../../table/table";
import Loader from "../../../loader/loader";
import { useDispatch, useSelector } from "react-redux";
import {
  AddLocnumberAction,
  DeleteLocnumberAction,
  GetCourtAction,
  GetLocTypeAction,
  GetLocnumberAction,
  UpdateLocnumberAction,
} from "../../../../redux/actions/CourtAction";
import notify from "../../../Notifcation";
import { ToastContainer } from "react-toastify";
const Circles = () => {
  const [NumberCirlce, setNumberCirlce] = useState("");
  const [TypeCircle, setTypeCircle] = useState("");
  const [Mahkama, setMahkama] = useState("");
  const [Note, setNote] = useState("");
  const [dIDCirclee, setdIDCirclee] = useState("");
  const [Itemss, setItemss] = useState("");
  const [Eye, setEye] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setdIDCirclee(itemid);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteLocnumberAction(dIDCirclee));
    setLoading(false);

    setshowDelete(false);
    setIsPress(false);
  };
  const ALL = useSelector((state) => state.CourtR.LoctypeNumber);
  const Mahkamaaa = useSelector((state) => state.CourtR.Courts);
  const Typecirclee = useSelector((state) => state.CourtR.Loctype);
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(GetLocnumberAction());
    dispatch(GetLocTypeAction());
    dispatch(GetCourtAction());
  }, []);
  useEffect(() => {
    if (Mahkama !== "") {
      // dispatch(
      //   GetLocnumberAction(`CourtId=${Mahkama}&LocationTypeId=${TypeCircle}`)
      // );
      dispatch(GetLocTypeAction(Mahkama));
    }
    if (Mahkama !== "" && TypeCircle !== "") {
      dispatch(
        GetLocnumberAction(`CourtId=${Mahkama}&LocationTypeId=${TypeCircle}`)
      );
    }
  }, [Mahkama, TypeCircle]);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (NumberCirlce === "" || TypeCircle === "" || Mahkama === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      AddLocnumberAction({
        Number: NumberCirlce,
        LocationTypeId: TypeCircle,
        Note: Note,
        CourtId: Mahkama,
      })
    );
    setNumberCirlce("");
    setNote("");
    setTypeCircle("");
    setMahkama("");
    setdIDCirclee("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (NumberCirlce === "" || TypeCircle === "" || Mahkama === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      UpdateLocnumberAction({
        Id: dIDCirclee,
        Number: NumberCirlce,
        LocationTypeId: TypeCircle,
        LocationType: Itemss.LocationType,
        Note: Note,
        CourtId: Mahkama,
        CourtName: Itemss.CourtName,
      })
    );
    setNumberCirlce("");
    setNote("");
    setTypeCircle("");
    setMahkama("");
    setdIDCirclee("");
    setIsEdit(false);
    setIsPress(false);
    setLoading(false);
  };
  const Update = (item) => {
    setNumberCirlce(item.Number);
    setNote(item.Note);
    setdIDCirclee(item.Id);
    setTypeCircle(item.LocationTypeId);
    setItemss(item);
    setMahkama(item.CourtId);
    setIsEdit(true);
    setEye(false);
  };
  const HandleEye = (item) => {
    setNumberCirlce(item.Number);
    setNote(item.Note);
    setdIDCirclee(item.Id);
    setTypeCircle(item.LocationTypeId);
    setMahkama(item.CourtId);

    setIsEdit(false);
    setEye(true);
  };
  const res = useSelector((state) => state.CourtR.AddLocNumber);
  const UP = useSelector((state) => state.CourtR.UpdateLoctypeNumber);
  const DEL = useSelector((state) => state.CourtR.DeleteLoctypeNumber);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage ===
              "Great, Location number created successfully"
          ) {
            notify("تم اضافة البيانات بنجاح", "success");
            // dispatch(GetLocnumberAction());
            dispatch(GetLocTypeAction());
            dispatch(GetCourtAction());
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.data.StatusCode === 200 || UP.data.StatusCode === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage === "Great, Court updated Successfully"
          ) {
            // dispatch(GetLocnumberAction());
            dispatch(GetLocTypeAction());
            dispatch(GetCourtAction());
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.StatusCode !== 200 || UP.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }

      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Great, Court deleted Successfully"
          ) {
            // dispatch(GetLocnumberAction());
            dispatch(GetLocTypeAction());
            dispatch(GetCourtAction());
            notify("تم حذف المحكمة بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "can't delete this because you are using it"
          ) {
            notify("لا يمكن حذف هذة المحكمة لانها مستخدمة", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    اسم المحكمة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="المحكمة"
                  value={Mahkama}
                  onChange={(e) => setMahkama(e.target.value)}>
                  {Array.isArray(Mahkamaaa) && Mahkamaaa.length > 0
                    ? Mahkamaaa.map((item) => (
                        <MenuItem key={item.Id} value={item.Id}>
                          {item.Name}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </div>

            <div className="inp-container">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    نوع الدائرة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="نوع الدائرة"
                  value={TypeCircle}
                  onChange={(e) => setTypeCircle(e.target.value)}>
                  {Array.isArray(Typecirclee) && Typecirclee.length > 0
                    ? Typecirclee.map((item) => (
                        <MenuItem key={item.Id} value={item.Id}>
                          {item.Type}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </div>
            <div className="inp-container">
              <div className=" ss">
                <TextField
                  value={NumberCirlce}
                  inputProps={{ maxLength: 15 }}
                  type="number"
                  onChange={(e) => setNumberCirlce(e.target.value)}
                  label={
                    <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                      رقم الدائرة
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                  variant="outlined"
                  //   className="ww"
                />
              </div>
            </div>
            <div className="inp-container">
              <TextField
                label="الملاحظات"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                value={Note}
                onChange={(e) => setNote(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? null : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          {/* <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                
                label="ابحث"
                variant="outlined"
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div> */}
        </Container>{" "}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                رقم الدائرة<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                نوع الدائرة <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                المحكمة <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(ALL) && ALL.length > 0
              ? ALL.map((item) => (
                  <tr key={item.Id} onDoubleClick={() => Update(item)}>
                    <td>{item.Number}</td>
                    <td>{item.LocationType}</td>
                    <td>{item.CourtName}</td>
                    <td>{item.Note}</td>
                    <td className="icon-w">
                      <i
                        onClick={() => Update(item)}
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        //onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleEye(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
        <div className="mod">
          <Modal
            show={showDelete}
            onHide={handleCloseDelete}
            backdrop="static"
            centered
            contentClassName="cont"
            keyboard={false}
            style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
            {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
            <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="close"
                onClick={handleCloseDelete}>
                إغلاق
              </Button>
              <Button
                variant="primary"
                className="edit"
                onClick={handelDeleteItem}>
                موافق
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
};
export default Circles;
